module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container",
    staticStyle: {
      "height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('modal', {
    attrs: {
      "height": 250,
      "pivotY": 0.5,
      "width": 300,
      "name": "add-new-suggestion"
    }
  }, [_c('div', {
    staticClass: "text-xs-center add-tag-container"
  }, [_c('h3', [_vm._v("Type the tag name!")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "#f5a623",
      "autofocus": true
    },
    model: {
      value: (_vm.addTagModal),
      callback: function($$v) {
        _vm.addTagModal = $$v
      },
      expression: "addTagModal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tag-add-button",
    on: {
      "click": function($event) {
        return _vm.addTagToSelected()
      }
    }
  }, [_vm._v("Add Tag")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "head-section"
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('div', [_c('i', {
    staticClass: "material-icons white--text",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('suggestions')
      }
    }
  }, [_vm._v("arrow_back_ios")])]), _vm._v(" "), _c('div', {
    staticClass: "done",
    on: {
      "click": function($event) {
        return _vm.emitArrayAsTextObjArr()
      }
    }
  }, [_vm._v("Done")])]), _vm._v(" "), _c('div', {
    staticClass: "head"
  }, [_c('div', [_vm._v(_vm._s(_vm.headTag))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.subheadTag))])])]), _vm._v(" "), _c('div', {
    staticClass: "input-section",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "input-header"
  }, [_vm._v("Your input")]), _vm._v(" "), _c('div', {
    staticClass: "clickable-modal-bg",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-suggestion')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "add-new-btn-suggestion pointer",
    on: {
      "click": function($event) {
        return _vm.$modal.show('add-new-suggestion')
      }
    }
  }, [_vm._v("Add new")]), _vm._v(" "), _c('div', {
    staticClass: "selected-suggestions"
  }, [(_vm.selectedSuggestions.length === 0) ? _c('div', {
    staticClass: "default-text"
  }, [_vm._v("Add a new one or select from the suggestions below.")]) : _c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((_vm.selectedSuggestions), function(suggestion, sIndex) {
    return _c('button', {
      key: ("" + sIndex),
      staticClass: "added-suggestions",
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("\n            " + _vm._s(_vm.selectedSuggestions.includes(suggestion) ?
      'cancel' : 'add') + "\n          ")]), _vm._v("\n          " + _vm._s(suggestion) + "\n        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "suggestion-section white--text"
  }, [_c('div', {
    staticClass: "suggestion-head"
  }, [_vm._v("SUGGESTIONS")]), _vm._v(" "), _c('div', {
    staticClass: "suggestions-container"
  }, _vm._l((_vm.suggestions), function(suggestion, sIndex) {
    return _c('div', {
      key: ("" + sIndex)
    }, [_c('button', {
      class: _vm.selectedSuggestions.includes(suggestion) ?
        'selected-suggestion' : 'unselected-suggestion',
      on: {
        "click": function($event) {
          return _vm.addOrRemove(suggestion)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("\n            " + _vm._s(_vm.selectedSuggestions.includes(suggestion) ?
      'cancel' : 'add') + "\n          ")]), _vm._v("\n          " + _vm._s(suggestion) + "\n        ")])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a58d1328","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadImage/suggestion-model.vue
// module id = 846
// module chunks = 6